<template>
  <BasePageSection class="pa-0" fluid :full-width="true">
    <VLayout wrap>
      <RestoInstagram
        :token="getIgAccessToken"
        :count="['xs', 'sm'].includes($mq) ? 4 : 8"
        :mediatypes="['IMAGE', 'VIDEO', 'CAROUSEL_ALBUM']"
        class="layout row wrap"
      >
        <template #feeds="{ feed }">
          <VFlex
            grow
            xs12
            sm6
            md3
            :style="{
              'padding-top': imgPadding[$mq],
              position: 'relative',
            }"
          >
            <a
              class="img-elem db-teal"
              :style="{
                top: 0,
                left: 0,
                height: 'calc( 100% - 20px )',
                width: 'calc( 100% - 20px )',
                margin: '10px',
                position: 'absolute',
                'background-image': `url(${
                  feed.media_type === 'VIDEO'
                    ? feed.thumbnail_url
                    : feed.media_url
                })`,
                'background-size': 'cover',
                'background-position': 'center center',
                'text-align': 'center',
              }"
              :href="feed.permalink"
              target="_blank"
            >
              <VIcon
                v-if="feed.media_type === 'VIDEO'"
                color="white"
                large
                style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"
                >play_circle_filled
              </VIcon>
            </a>
            <!-- <img :src="feed.images.standard_resolution.url" /> -->
          </VFlex>
        </template>
        <template #error="{ error }">
          <VFlex v-if="!!error" text-xs-center>
            <div v-if="loggedIn">
              {{ error }}
            </div>
            <div v-else>The Instagram feed couldn't be loaded.</div>
          </VFlex>
        </template>
      </RestoInstagram>
    </VLayout>
  </BasePageSection>
</template>

<script>
import { mapGetters } from 'vuex'

import RestoInstagram from '@components/RestoInstagram'

export default {
  name: 'SectionInstagram',
  components: { RestoInstagram },
  props: {},
  data() {
    return {
      imgPadding: {
        xs: '100%',
        sm: '100%',
        md: '50%',
        lg: '25%',
        xl: '25%',
      },
    }
  },
  computed: {
    ...mapGetters('site', ['getIgAccessToken']),
    ...mapGetters('auth', ['loggedIn']),
  },
}
</script>
